module.exports = __webpack_public_path__ + "static/media/card_upload_selfie.82a0e914.svg";